<template>
  <div v-if="app === 'WEB_SHOP'" id="webshop" class="outer-container">
    <purchase-license />
  </div>
  <div id="app" class="app outer-container" v-else>
    <!--
    <nav class="nav">
      <div class="nav-inner">
        <div class="nav-left">
          <div class="nav-item nav-item-logo">
            <img @click="navigateTo('', $i18n.locale)" src="/main-logo.png" />
          </div>
        </div>

        <div class="nav-right">
          <div v-if="$i18n.locale === 'sv'" class="nav-item">
            <a href="#heading-purchase" @click="navigateTo('#heading-license', $i18n.locale)">
              {{ $t("navigation.license") }}
            </a>
          </div>
          <div class="nav-item">
            <a href="#heading-about" @click="navigateTo('#heading-about', $i18n.locale)">
              {{ $t("navigation.about") }}
            </a>
          </div>
          <div v-if="$i18n.locale === 'en'" class="nav-item">
            <a href="#heading-purchase" @click="navigateTo('#heading-purchase', $i18n.locale)">
              {{ $t("navigation.purchase") }}
            </a>
          </div>
          <div class="nav-item">
            <a href="mailto:support@bisgraf.freshdesk.com">
              {{ $t("navigation.contact") }}
            </a>
          </div>
          <div class="nav-item nav-item-login">
            <a href="https://app.bisgraf.com/login" class="button">
              {{ $t("navigation.login") }}
            </a>
          </div>
          <div class="nav-item nav-item-lang">
            <span @click="changeLocale('en')" :class="{ highlight: $i18n.locale === 'en' }">en</span>/<span
              @click="changeLocale('sv')" :class="{ highlight: $i18n.locale === 'sv' }">sv</span>
          </div>

          <div class="powered-by-img nav-item">
            <a href="https://bonanza.se/" target="_blank"><img src="/bonanza-logo.png" /></a>
          </div>
        </div>
      </div>
    </nav>
    -->

    <main class="main">
      <div>
        <iframe
          style="border: none"
          id="bisgrafNavIframe"
          ref="bisgrafNavIframe"
          :src="
            $i18n.locale === 'sv'
              ? 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/nav_sv.html'
              : 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/nav_en.html'
          "
          width="100%"
        ></iframe>
      </div>
      <div
        v-if="component === 'STRIPE_SUCCESS'"
        class="response-message success"
      >
        <img src="/success.png" />
        <h3>{{ $t("purchaseLicense.responses.createSuccessTitle") }}</h3>
        <p>{{ $t("purchaseLicense.responses.createSuccess") }}</p>
      </div>

      <div
        v-else-if="component === 'STRIPE_SUCCESS_EXISTING_USER'"
        class="response-message success"
      >
        <img src="/success.png" />
        <h3>{{ $t("purchaseLicense.responses.updateSuccessTitle") }}</h3>
        <button
          @click="navigateTo('https://app.bisgraf.com/login')"
          class="button"
        >
          {{ $t("purchaseLicense.responses.successCTA") }}
        </button>
      </div>

      <div
        v-else-if="component === 'STRIPE_UPDATE_SUCCESS'"
        class="response-message update-success"
      >
        <img src="/success.png" />
        <h3>{{ $t("purchaseLicense.responses.updateSuccessTitle") }}</h3>
      </div>
      <div
        v-else-if="component === 'STRIPE_UPDATE_FAILURE'"
        class="response-message update-failure"
      >
        <img src="/cancel.png" />
        <h3>{{ $t("purchaseLicense.responses.updateFailureTitle") }}</h3>
        <p>
          {{ $t("purchaseLicense.responses.updateFailureText") }}
        </p>
        <br />
        <br />
        <a href="mailto:support@bisgraf.freshdesk.com" class="button">
          {{ $t("generic.contactUs") }}
        </a>
      </div>

      <div v-else>
        <iframe
          style="border: none"
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
          allowfullscreen="true"
          scrolling="no"
          id="bisgrafTopIframe"
          ref="bisgrafTopIframe"
          :src="
            $i18n.locale === 'sv'
              ? 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/top_sv.html'
              : 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/top_en.html'
          "
          width="100%"
        ></iframe>
        <section id="licenses">
          <purchase-license :selectedLicenseMode.sync="selectedLicenseMode" />
        </section>
      </div>
      <div id="heading-about">
        <iframe
          class="heading-about"
          style="border: none"
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
          allowfullscreen="true"
          scrolling="no"
          id="bisgrafBottomIframe"
          ref="bisgrafBottomIframe"
          :src="$i18n.locale === 'sv' ? 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/bottom_sv.html' : 'https://mybonanzafiles.bonanza.se/files/bisgraftopbottom/bottom_en.html'"
          width="100%"
        >
        </iframe>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import PurchaseLicense from "./components/PurchaseLicense.vue";
// import About from "./components/About.vue";
// import HeroSection from "./components/HeroSection.vue";
// import Footer from "./components/Footer.vue";
import { navigateTo } from "./Utils/Utils.ts";
import { SUPPORTED_LOCALES, SWEDISH_LOCALE, ENGLISH_LOCALE } from "./constants";

export default Vue.extend({
  name: "App",
  components: {
    PurchaseLicense
    // About,
    // Footer,
    // HeroSection,
  },
  data() {
    return {
      app: "MAIN",
      component: "MAIN",
      selectedLicenseMode: null,
    };
  },

  created() {
    const localeFromPathName = window.location.pathname.substring(1, 3);
    const localeFromNavigator = window.navigator.language.substring(0, 2);
    if (SUPPORTED_LOCALES.includes(localeFromPathName)) {
      this.$i18n.locale = localeFromPathName;
      Vue.prototype.$currency = this.getCurrencyFromLocale(localeFromPathName);
    } else if (SUPPORTED_LOCALES.includes(localeFromNavigator)) {
      this.$i18n.locale = localeFromNavigator;
      Vue.prototype.$currency = this.getCurrencyFromLocale(localeFromNavigator);
    } else {
      this.$i18n.locale = SWEDISH_LOCALE;
      Vue.prototype.$currency = "SEK";
    }

    const [path] = window.location.pathname
      .split("/")
      .filter(item => item !== "");

    switch (path) {
      case "web-shop":
        this.app = "WEB_SHOP";
        break;
      case "success":
        this.component = "STRIPE_SUCCESS";
        break;
      case "success-existing-user":
        this.component = "STRIPE_SUCCESS_EXISTING_USER";
        break;
      case "update-success":
        this.component = "STRIPE_UPDATE_SUCCESS";
        break;
      case "update-failure":
        this.component = "STRIPE_UPDATE_FAILURE";
        break;
      case "":
      default:
        break;
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("status");
    window.addEventListener("message", this.receiveMessage, false);
    switch (status) {
      case "success":
        window.alert("Congratualations on your purchase!");
        break;
      case "cancelled":
        window.alert("Please contiue shopping!");
        break;
      default:
      //console.log("unknown status");
    }
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed to avoid memory leaks
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    navigateTo,
    changeLocale(locale) {
      location.replace(`/${locale}/`);
    },

    receiveMessage(event) {
      if (event.origin === 'https://mybonanzafiles.bonanza.se') {
        const data = event.data;
        //nav-bar iframe
        if (event.source === this.$refs.bisgrafNavIframe.contentWindow) {
          const data = event.data;

          if (data && data.setHeightNavIframe) {
            this.$refs.bisgrafNavIframe.style.height =
              data.setHeightNavIframe + "px";
          }
          if (data && data.setLanguage) {
            this.changeLocale(data.setLanguage);
          }

          if (data && data.scrollToId) {
            this.scrollToElement(`#${data.scrollToId}`, this.$i18n.locale);
          }

        }

        //bottom iframe
        if (event.source === this.$refs.bisgrafBottomIframe.contentWindow) {
          if (data && data.setHeightBottomIframe) {
            this.$refs.bisgrafBottomIframe.style.height =
              data.setHeightBottomIframe + "px";
          }
        }

        //top iframe
        if (event.source === this.$refs.bisgrafTopIframe.contentWindow) {
          const data = event.data;
          if (data && data.setHeightTopIframe) {
            this.$refs.bisgrafTopIframe.style.height =
              data.setHeightTopIframe + "px";
          }
          if (data && data.scrollToId) {
            this.scrollToElement(`#${data.scrollToId}`, this.$i18n.locale);
          }
        }
      }
    },

    scrollToElement(elementId, locale) {
      const newUrl = `/${locale}/${elementId}`;
      history.pushState(null, null, newUrl);

      const element = document.querySelector(elementId);
      if (element) {
        element.scrollIntoView();
      }
    },
    getCurrencyFromLocale(locale) {
      switch (locale) {
        case ENGLISH_LOCALE:
          return "EUR";
        case SWEDISH_LOCALE:
        default:
          return "SEK";
      }
    }
  }
});
</script>
